import React from "react";
import { EHappyHourLocation } from "@src/lib/happyHour/types/HappyHour.interface";
import { useAppSelector } from "@src/store/hooks";
import HappyHourBanner from "../../../../lib/happyHour/components/HappyHourBanner";
import StandardBannerWrapper from "./StandardBannerWrapper";
import "./TopBanner.styles.scss";
import { useHappyHourMessageByLocation } from "@src/lib/happyHour/hooks/useHappyHourMessageByLocation";
import { useHappyHourAlertVisibility } from "@src/lib/happyHour/components/HappyHourAlert/useHappyHourAlertVisibility";
import { useHappyHourContext } from "@src/lib/happyHour/HappyHourContext";

interface ITopBannerProps {
  location?: EHappyHourLocation;
  onToggleTopBanner?: (visible: boolean) => void;
}

const TopBanner = (props: ITopBannerProps) => {
  const { onToggleTopBanner, location } = props;
  const { hideTopBanner } = useAppSelector(({ cart }) => cart);
  const { topBannerClosed } = useHappyHourContext();
  const happyHourMessage = useHappyHourMessageByLocation(location);
  const happyHourVisible = useHappyHourAlertVisibility(happyHourMessage);

  // Prioriser Happy Hour si disponible, sinon afficher le banner standard
  if (happyHourVisible && !topBannerClosed) {
    return (
      <HappyHourBanner
        location={location}
        onToggleTopBanner={onToggleTopBanner}
      />
    );
  }

  // Si le banner est masqué globalement, ne rien afficher
  if (hideTopBanner) {
    return null;
  }

  return <StandardBannerWrapper onToggleTopBanner={onToggleTopBanner} />;
};

export default TopBanner;
